export const VIEW_MODES = {
  list: "list",
  map: "map",
} as const;

export type ViewMode = (typeof VIEW_MODES)[keyof typeof VIEW_MODES];
